import Vue from 'vue'
import Vuex from 'vuex'
import { createStore } from 'vuex-extensions'; 
import users from './modules/users';
import layers from './modules/layers';
import infographics from './modules/infographics';
import tools from './modules/tools';
import plan from './modules/plan';

Vue.use(Vuex);

const DASHBOARD_MODE = 'Dashboard';
const TOOL_MODE = 'MEP Tool';

export default createStore(Vuex.Store, {
    state: {
        mode: DASHBOARD_MODE,
        reloadRequired: false,
    },
    getters: {
        getMode: state => state.mode,
        reloadRequired: state => state.reloadRequired,
        getOtherMode: state => state.mode===DASHBOARD_MODE ? TOOL_MODE : DASHBOARD_MODE,
        isDashboardMode: state => state.mode===DASHBOARD_MODE,
        // these should be used in the components to decide wether to show results or not
        // here we combine the logic of where or not we show the results of plan or mhp tools
        showMhpResults: (state, getters) => getters['tools/showMhpResults'] || getters['plan/showMhpResults'],
        showBatResults: (state,getters) => getters['tools/showBatResults'] || getters['plan/showBatResults'],
        showSstResults: (state,getters) => getters['tools/showSstResults'] || getters['plan/showSstResults'],
        showResults: (state,getters) => getters['tools/showResults'] || getters['plan/showResults'],
        getMhpResults: (state, getters) =>
        {
            if (getters['plan/showMhpResults']) return getters['plan/getMhpResults'];
            if (getters['tools/showMhpResults']) return getters['tools/getMhpResults'];
            return null;
        },
        getBatResults: (state,getters) =>
        {
            if (getters['plan/showBatResults']) return getters['plan/getBatResults'];
            if (getters['tools/showBatResults']) return getters['tools/getBatResults'];
            return null;
        },
        getSstResults: (state,getters) =>
        {
            if (getters['plan/showSstResults']) return getters['plan/getSstResults'];
            if (getters['tools/showSstResults']) return getters['tools/getSstResults'];
            return null;
        },
    },
    actions: {
        toggleMode: ({state, commit}) =>
        {
            commit('SET_MODE', state.mode===DASHBOARD_MODE ? TOOL_MODE : DASHBOARD_MODE);
        },
        setReloadRequired: ({commit}, value) =>
        {
            commit('SET_RELOAD_REQUIRED', value);
        },
    },
    mutations: {
        SET_MODE: (state, mode) =>
        {
            console.assert([DASHBOARD_MODE, TOOL_MODE].includes(mode));
            state.mode = mode;
        },
        SET_RELOAD_REQUIRED: (state, value) =>
        {
            state.reloadRequired = value;
        }
    },
    modules: {
        users,
        layers,
        infographics,
        tools,
        plan,
    }
});
